import Swiper from 'swiper/dist/js/swiper.min.js';

jQuery(document).ready(function($) {
    if ($('.employees-carousel').length) {
        const employees_carousel_slider = document.querySelectorAll('.employees-carousel-slides');
        const employees_carousel_text_slider = document.querySelectorAll('.employees-carousel-text-slides');

        for (let i = 0; i < employees_carousel_slider.length; i++) {
            employees_carousel_slider[i].classList.add('employees-carousel-slides-' + i);
            employees_carousel_text_slider[i].classList.add('employees-carousel-text-slides-' + i);

            let employees_text_slider = new Swiper('.employees-carousel-text-slides-' + i, {
                spaceBetween: 0,
                slidesPerView: 1,
                loop: true,
                loopedSlides: 4,
                effect: 'fade',
                speed: 1000,
                autoplay: false,
                keyboard: false,
                noSwiping: true,
                allowSlidePrev: false,
                allowSlideNext: false,
            });

            let employees_slider = new Swiper('.employees-carousel-slides-' + i, {
                slidesPerView: 'auto',
                speed: 1000,
                // autoplay: {
                //     delay: 3000,
                // },
                autoplay: false,
                effect: 'coverflow',
                centeredSlides: true,
                loop: true,
                loopedSlides: 4,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 80,
                    depth: 150,
                    modifier: 2,
                    slideShadows: false,
                },
                navigation: {
                    prevEl: '.powered-prev-button',
                    nextEl: '.powered-next-button',
                },
                breakpoints: {
                    768: {
                        coverflowEffect: {
                            rotate: 0,
                            stretch: 50,
                            depth: 100,
                            modifier: 2,
                            slideShadows: false,
                        },
                    },
                },
            });

            employees_slider.controller.control = employees_text_slider;
        }
    }
});


// WEBPACK FOOTER //
// ./scripts/blocks/employees-carousel.js